import axios from 'axios';
import { createFamilyFileUploadUrl } from '../../../service/FileApi';
export async function FileUpload(file, category, subcategory, identifierValue) {
    if (!file) {
        throw new Error("No file provided for upload.");
    }
    if (!category || !identifierValue) {
        throw new Error("Category and identifierValue is required for file upload categorization.");
    }
    if (!subcategory) {
        throw new Error("subcategory is required for file upload categorization.");
    }

    try {
        // 1. Request a signed URL for upload from the backend
        const uploadUrlResponse = await createFamilyFileUploadUrl(
            JSON.stringify(
                {
                    fileName: file.name,
                    contentType: file.type,
                    identifierValue,
                    category,
                    subcategory
                }
            )
        );

        if (uploadUrlResponse !== false) {
            const { signedUrl, fileName } = uploadUrlResponse;

            const directUploadResponse = await axios.put(signedUrl, file, {
                headers: {
                    'Content-Type': file.type, // IMPORTANT: Must match the content-type used in generateSignedUrl
                }
            });

            if (directUploadResponse.status !== 200) {
                throw new Error(directUploadResponse.message);
            }
            return fileName; // Return the full GCS path
        }
        else {
            throw new Error(uploadUrlResponse.message || 'URL creation failed');
        }

    } catch (error) {
        console.error("Error in uploadFileToGCS:", error);
        throw new Error(error);
    }
}
